import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { postReservations } from "source/registrations/api/reservations"
import { Loading, AlertMessage } from "source/shared/components"
import useQueryString from "source/shared/hooks/useQueryString"

const New = () => {
  const navigate = useNavigate()
  const { eventId, eventSignupPath } = useParams()
  const [error, setError] = useState(null)

  const [params] = useQueryString()

  const createReservation = async () => {
    const { errors, data: reservation } = await postReservations(eventId, {
      type: "Reservation",
      data: { attributes: {} },
    })

    if (errors) {
      setError(errors[0].detail)
    } else {
      navigate(
        `/registrations/${eventSignupPath}/${eventId}/reservations/${
          reservation.id
        }${params.source ? `?source=${params.source}` : ""}`,
        { replace: true },
      )
    }
  }

  useEffect(() => {
    createReservation()
  }, [])

  return error ? <AlertMessage>{error}</AlertMessage> : <Loading />
}

export default New
